var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5300",
    "data-name": "Group 5300",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5299",
    "data-name": "Group 5299",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_262",
    "data-name": "Ellipse 262",
    fill: "none",
    stroke: "#e3ebf1",
    strokeWidth: 1,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(5.857 5.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_892",
    "data-name": "Rectangle 892",
    width: 24.286,
    height: 24.286,
    fill: "#3cc2e0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12455",
    "data-name": "Path 12455",
    d: "M19.662,20.657H4.523A2.493,2.493,0,0,1,2,18.2V5.952A2.493,2.493,0,0,1,4.523,3.5H9.166a1.009,1.009,0,0,1,.777.373l2.624,3.209h7.065a2.493,2.493,0,0,1,2.553,2.452V18.2A2.493,2.493,0,0,1,19.662,20.657Zm-15.643-6.8V18.2a.464.464,0,0,0,.5.434H19.662a.464.464,0,0,0,.5-.434V9.535a.464.464,0,0,0-.5-.434H12.092a1.009,1.009,0,0,1-.777-.373L8.691,5.518H4.523a.464.464,0,0,0-.5.434Z",
    transform: "translate(0.018 0.032)",
    fill: "#3cc2e0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSub);
export default __webpack_public_path__ + "static/media/totalSub.69eb8746f14c393e84bc998a72a658d7.svg";
export { ForwardRef as ReactComponent };